module.exports = __webpack_public_path__ + "web/img/avi.8d929590.png";